import { Box, LinearProgress } from '@mui/material';

export const PriceCellLoadingIndicator = () => {
    return (
        <Box
            component="div"
            sx={{
                position: 'absolute',
                width: '100%',
                height: '2px',
                bottom: '-1px',
                left: '0px'
            }}
        >
            <LinearProgress />
        </Box>
    );
};
